module.exports = __webpack_public_path__ + "media/ecom/ArrowLeft-9dc8f00d.svg";